import { render } from "./WarningTestModal.vue?vue&type=template&id=2e41a0af&ts=true"
import script from "./WarningTestModal.vue?vue&type=script&lang=ts"
export * from "./WarningTestModal.vue?vue&type=script&lang=ts"

import "./WarningTestModal.vue?vue&type=style&index=0&id=2e41a0af&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__